import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getThisYear
} from "../../../../utils/date-range-options";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_DATES,
  FETCH_CHART_SUCCESS,
  SET_UPDATES_LOADING,
  RESET_FILTER_SELECTED,
  UPDATE_SHOW_NET_REVENUE_SELECTED,
  UPDATE_SHOW_EXPENSES_SELECTED,
  UPDATE_PERIOD_TYPE,
  UPDATE_TABLE_VIEW_SELECTED,
  UPDATE_CUSTOM_RANGE,
  UPDATE_REVENUE_VIEW_SELECTED,
  TOGGLE_PREDICTION_SELECTED,
  FETCH_PREDICTION_SUCCESS,
  SET_PREDICTION_LOADING
} from "./totalRevenueSalesSagas";
import { DEFAULT_TOTAL_REVENUE_VIEW } from "../../ViewFilter";

export const initialState = {
  currentUser: {},
  initialRequest: false,
  chartData: {},
  isLoading: true,
  updatesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  filters: {
    toggles: {}
  },
  selectedRevenueView: DEFAULT_TOTAL_REVENUE_VIEW,
  showPrediction: false,
  predictionChart: {},
  isPredictionLoading: false,
  selectedFilters: {
    period_type: "Monthly",
    table_view: false,
    include_returns: false,
    show_expenses: false,
    group_categories: 1
  },
  periodTypeOptions: ["Daily", "Weekly", "Monthly", "Quarterly", "Yearly"],
  selectedRangeOption: {
    id: 1,
    name: getThisYear(undefined, true)
  },
  rangeOptions: getRangeOptions(undefined, true)
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),

    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      const rangeOptions = getRangeOptions(
        action.payload.endDate,
        state.currentUser.calendarStartDate
      );
      return {
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser,
      initialRequest: true
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload || state.chartData
    }),
    [FETCH_FILTERS_SUCCESS]: (state, { payload }) => {
      let {
        toggles: { includeReturns = {}, showExpenses = {} }
      } = payload;

      return {
        ...state,
        filters: payload,
        selectedFilters: {
          ...state.selectedFilters,
          include_returns: includeReturns.default ?? state.selectedFilters.include_returns,
          show_expenses: showExpenses.default ?? state.selectedFilters.show_expenses
        }
      };
    },
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: {
        ...initialState.selectedFilters,
        include_returns: state.filters.toggles.includeReturns.default,
        show_expenses: state.filters.toggles?.showExpenses?.default ?? false
      }
    }),
    [UPDATE_SHOW_NET_REVENUE_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        include_returns: action.payload
      }
    }),
    [UPDATE_SHOW_EXPENSES_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        show_expenses: action.payload
      }
    }),
    [UPDATE_PERIOD_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        period_type: action.payload
      }
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [UPDATE_REVENUE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedRevenueView: action.payload
    }),
    [TOGGLE_PREDICTION_SELECTED]: (state, { payload }) => ({
      ...state,
      showPrediction: payload,
      predictionChart: payload ? state.predictionChart : {}
    }),
    [FETCH_PREDICTION_SUCCESS]: (state, { payload }) => ({
      ...state,
      predictionChart: payload
    }),
    [SET_PREDICTION_LOADING]: (state, { payload }) => ({
      ...state,
      isPredictionLoading: payload
    })
  },
  initialState
);
